import { render, staticRenderFns } from "./assignedPhoneHistory.vue?vue&type=template&id=6dbf7a0a&scoped=true&"
import script from "./assignedPhoneHistory.vue?vue&type=script&lang=ts&"
export * from "./assignedPhoneHistory.vue?vue&type=script&lang=ts&"
import style0 from "./assignedPhoneHistory.vue?vue&type=style&index=0&id=6dbf7a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf7a0a",
  null
  
)

export default component.exports